import {
  ApiClient,
  appWatchClient,
  contentClient,
  engagementClient,
  identityClient,
  mediaClient,
  paymentClient,
  affiliateClient,
  paymentWithoutPlatformClient,
  publicIdentityAffiliateClient,
  publicAppWatchClient,
  publicContentClient,
  publicEngagementClient,
  publicIdentityClient,
  publicMediaClient,
  publicPaymentClient,
  publicPaymentWithoutPlatformClient,
  Server,
  mediaUploadClient,
  publicMediaUploadClient,
} from '@wajeez-web/core/api-base';
import { store } from '@wajeez-web/stores/base';
import { getAuthState, TokenService } from '@wajeez-web/stores/auth';
import {
  AlertType,
  CommonActions,
  getCommonState,
} from '@wajeez-web/stores/common';
import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export const setupInterceptor = (
  api: AxiosInstance = ApiClient,
  withoutToken?: boolean,
  withoutPlatform = false
) => {
  if (!withoutToken)
    api.interceptors.request.use(
      async (
        config: InternalAxiosRequestConfig
      ): Promise<InternalAxiosRequestConfig> => {
        console.log('adding token to request')
        const token: string | null =
          (await TokenService.getAccessTokenForUsageService()) ||
          getAuthState(store).b2bLogin.data?.token ||
          null;

        const languageId =
          config.headers['x-app-language-id'] ||
          getCommonState(store).common.settings?.LanguageId + '';

        const language = languageId === '1' ? 'ar' : 'en';

        const exConfig = {
          ...config,
          headers: {
            ...config.headers,
            Authorization: token
              ? 'Bearer ' + token
              : 'Bearer ' + getAuthState(store).token,
            'accept-language':
              language || getCommonState(store).common.settings?.lang,
            'x-app-version': '12.6.9',
            'x-app-language-id': languageId,
          } as any,
          params: {
            ...config.params,
            culture: language || getCommonState(store).common.settings?.lang,
            cacheInvalidator: new Date().getMilliseconds(),
          },
        };

        if (!withoutPlatform) {
          exConfig.headers['x-app-platform'] = Server.XAppPlatform.IOS;
        }

        if (exConfig.method === 'get') {
          exConfig.headers['Cache-Control'] = 'no-cache';
        }

        return exConfig;
      },
      (error) => {
        if (error.message !== 'canceled') {
          return Promise.reject(error);
        }
        return Promise.resolve(null);
      }
    );
  else
    api.interceptors.request.use(
      async (
        config: InternalAxiosRequestConfig
      ): Promise<InternalAxiosRequestConfig> => {
        console.log('without adding token to request')

        const languageId =
          config.headers['x-app-language-id'] ||
          getCommonState(store).common.settings?.LanguageId + '';

        const language = languageId === '1' ? 'ar' : 'en';

        const exConfig = {
          ...config,
          headers: {
            ...config.headers,
            'accept-language':
              language || getCommonState(store).common.settings?.lang,
            'x-app-language-id': languageId,
          } as any,
          params: {
            ...config.params,
            culture: language || getCommonState(store).common.settings?.lang,
            cacheInvalidator: new Date().getMilliseconds(),
          },
        };

        if (exConfig.method === 'get') {
          exConfig.headers['Cache-Control'] = 'no-cache';
        }

        return exConfig;
      },
      (error) => {
        if (error.message !== 'canceled') {
          return Promise.reject(error);
        }
        return Promise.resolve(null);
      }
    );

  api.interceptors.response.use(
    async (res) => {
      // store.dispatch(
      //   CommonActions.setAlert({
      //     for: getCommonState(store).common.alert.for,
      //     messages: null,
      //     show: false,
      //     type: null,
      //   })
      // );
      // store.dispatch(CommonActions.hideLoading());
      return res;
    },
    async (err) => {
      if (err.message !== 'canceled') {
        const originalConfig = err.config;
        // store.dispatch(CommonActions.hideLoading());
        if (originalConfig?.url !== 'login' && err.response) {
          // Access Token was expired
          if (
            err.response.status >= 500 &&
            !originalConfig.url.includes('lookups')
          ) {
            store.dispatch(
              CommonActions.setError({
                show: true,
                type: err.response.status >= 500 ? 500 : 403,
              })
            );
          } else if (err.response.status === 401 && !originalConfig._retry) {
            // TODO: If we are here, it means that we need to logout
            // originalConfig._retry = true;
            // try {
            //   const rs = await identityApi.post("account/token/refresh", {
            //     token: TokenService.getLocalAccessToken(),
            //     refreshToken: TokenService.getLocalRefreshToken(),
            //   });
            //   const data = rs.data.data;
            //   const user = {
            //     user: { id: data.id, name: data.name, email: data.email },
            //     refreshToken: data.refreshToken,
            //     token: data.token,
            //   };
            //   store.dispatch<any>(AuthActions.refreshToken(user));
            //   TokenService.updateLocalAccessToken(data.token);
            //   TokenService.setUser(user);
            //   return api(originalConfig);
            // } catch (_error) {
            //   TokenService.removeUser();
            //   store.dispatch<any>(AuthActions.signOut());
            //   return Promise.reject(_error);
            // }
          } else if (err.response.status === 400) {
            let errors = JSON.parse(err.response.data).errors;

            errors = errors.filter(
              (error: any) => error.message !== 'شركة غير مسجلة'
            );

            store.dispatch(
              CommonActions.setAlert({
                for: 'page',
                show: true,
                messages: errors || [{ message: 'Something went wrong' }],
                type: AlertType.ERROR,
              })
            );

            store.dispatch(CommonActions.hideLoading());
          }
        }

        return Promise.reject(err);
      }
      return Promise.reject(err);
    }
  );
};

export const setupInterceptors = () => {
  setupInterceptor(ApiClient);
  setupInterceptor(appWatchClient);
  setupInterceptor(publicAppWatchClient, true);
  setupInterceptor(contentClient);
  setupInterceptor(publicContentClient, true);
  setupInterceptor(engagementClient);
  setupInterceptor(publicEngagementClient, true);
  setupInterceptor(identityClient);
  setupInterceptor(publicIdentityClient, true);
  setupInterceptor(publicIdentityAffiliateClient, true);
  setupInterceptor(mediaClient);
  setupInterceptor(publicMediaClient, true);
  setupInterceptor(mediaUploadClient);
  setupInterceptor(publicMediaUploadClient, true);
  setupInterceptor(paymentClient);
  setupInterceptor(affiliateClient);
  setupInterceptor(paymentWithoutPlatformClient, false, true);
  setupInterceptor(publicPaymentClient, true);
  setupInterceptor(publicPaymentWithoutPlatformClient, true, true);
  // setupInterceptor(store,syncClient, clearAlert, hideLoading, setError, setAlert);
  // setupInterceptor(store,publicSyncClient, clearAlert, hideLoading, setError, setAlert,true);
};
